"use client"

import { useEffect, useRef } from "react"

import { releaseEarlyCheckoutTap, type HeldCheckoutTap } from "@/lib/checkout/pdp-checkout-link"

export const useEarlyCheckoutTap = (checkout: (tap: HeldCheckoutTap) => void) => {
  const checkoutOnMount = useRef(checkout)
  useEffect(() => {
    const tap = releaseEarlyCheckoutTap()
    if (tap) checkoutOnMount.current(tap)
  }, [])
}
